<template>
  <Draggable
    v-if="funnelStages.length"
    v-model="funnelStages"
    group="funnelStages"
    tag="ul"
    handle=".handle"
    class="divide-y border rounded-lg"
    :disabled="reordering"
    @change="handleOnChange"
  >
    <li
      v-for="funnelStage in funnelStages"
      :key="funnelStage.id"
      class="pr-4 py-4 hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg"
    >
      <slot name="funnel-stage" :funnel-stage="funnelStage" :reordering="reordering" />
    </li>
  </Draggable>
  <div v-else class="text-center">
    <slot name="empty-state">
      <p class="text-center">No items found.</p>
    </slot>
  </div>
</template>

<script>
import { reorderedFunnelStagesClient } from '@/api/clients';
import Draggable from 'vuedraggable';

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    funnelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reordering: false,
    };
  },
  computed: {
    funnelStages: {
      get() {
        return this.value;
      },
      set(funnelStages) {
        this.$emit('input', funnelStages);
      },
    },
  },
  methods: {
    async handleOnChange() {
      try {
        this.reordering = true;
        const response = await reorderedFunnelStagesClient.store(this.funnelId, {
          funnel_stages: this.funnelStages.map((funnelStage) => funnelStage.id),
        });

        this.funnelStages = response.data;
      } catch (error) {
        //
      } finally {
        this.reordering = false;
      }
    },
  },
};
</script>
